export {};

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString: string, position: number = 0) {
        return this.indexOf(searchString, position) === position;
    };
}

if (!String.prototype.endsWith) {
    String.prototype.endsWith = function(searchString: string, position: number) {
        var subjectString = this.toString();
        if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
            position = subjectString.length;
        }
        position -= searchString.length;
        var lastIndex = subjectString.indexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    };
}

if (!String.prototype.includes) {
    String.prototype.includes = function(search: string, start: number) {
        'use strict';
        if (typeof start !== 'number') {
            start = 0;
        }

        if (start + search.length > this.length) {
            return false;
        } else {
            return this.indexOf(search, start) !== -1;
        }
    };
}

if (!String.isNullOrEmpty) {
    String.isNullOrEmpty = (str: string) => {
        return str == null || str === "";
    };
}

if (!String.isNullOrUndefined) {
    String.isNullOrUndefined = (str: string) => {
        return str == null || str === undefined;
    };
}

if (!String.prototype.format) {
    String.prototype.format = function(...args) {
        return this.replace(/{(\d+)}/g, (match: string, number: number) => {
            return typeof args[number] != 'undefined'
                ? args[number]
                : match
                ;
        });
    };
}

if (!Number.parseFloat && parseFloat) {
    Number.parseFloat = parseFloat;
}

if (!Number.isNullOrUndefined) {
    Number.isNullOrUndefined = (number: number) => {
        return number == null || number === undefined;
    };
}

if (!String.prototype.hashCode) {
    String.prototype.hashCode = function() {
        var hash = 0;
        if (this.length == 0) return hash;
        for (let i = 0; i < this.length; i++) {
            let char = this.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }
}

if (!Boolean.isNullOrUndefined) {
    Boolean.isNullOrUndefined = (bool: boolean) => {
        return bool == null || bool === undefined;
    };
}